module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES3CUC2']['10']) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "details1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "detail-block"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC2']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_c('a', {
    attrs: {
      "data-toggle": "modal",
      "data-target": "#hres3cu-popup-complaint"
    },
    on: {
      "click": function($event) {
        _vm.toggleDetailComplaint()
      }
    }
  }, [_vm._v(_vm._s(_vm.indexSelected.numcom))])])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC2']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.indexSelected.codempid) + " - " + _vm._s(_vm.indexSelected.desc_codempid) + " ")])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC2']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.indexSelected.desc_codcomp))])])])])])])])]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.detailProcessColumns,
      "nowLang": _vm.nowLang,
      "data": _vm.detailProcess.table,
      "searchDisp": false,
      "addEvent": _vm.addEvent,
      "editEvent": _vm.editEvent,
      "saveInlineEvent": _vm.callSave,
      "addBtnDisp": _vm.validateStaappr,
      "editInlineEventBool": _vm.validateStaappr,
      "rowDisableCondition": _vm.rowDisableCondition,
      "saveInlineBtnDisp": _vm.validateStaappr,
      "deleteInlineEventBool": _vm.validateStaappr,
      "deleteInlineBtnDisp": false
    }
  }), _vm._v(" "), _c('popup-process', {
    attrs: {
      "labels": _vm.labels,
      "nowLang": _vm.nowLang,
      "labelsButton": _vm.labelsButton,
      "indexSelected": _vm.indexSelected,
      "searchIndex": _vm.searchIndex,
      "detailPopupProcess": _vm.detailPopupProcess,
      "postHres3cuDetailprocessPopup": _vm.postHres3cuDetailprocessPopup,
      "validateStaappr": _vm.validateStaappr
    }
  }), _vm._v(" "), _c('popup-complaint', {
    attrs: {
      "labels": _vm.labels,
      "nowLang": _vm.nowLang,
      "detail": _vm.detail,
      "labelsButton": _vm.labelsButton,
      "indexSelected": _vm.indexSelected
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))]), _vm._v(" "), _c('input', {
    ref: "popupProcessAddBtn",
    attrs: {
      "type": "hidden",
      "data-toggle": "modal",
      "data-target": "#hres3cu-detail-process-popup"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f0a2955!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres3cu/detailProcess.vue
// module id = 3661
// module chunks = 1